import { CommonResponse, ErrorResponse } from 'src/types';
import { isErrorResponse, isSuccessResponse } from 'src/utils/response-type-guards';

export async function runWithCallbacks<T>(
  fn: () => Promise<CommonResponse<T>>,
  onSuccess: (data: T) => void,
  onError: (error: ErrorResponse) => void
) {
  const response = await fn();

  if (isSuccessResponse(response)) {
    onSuccess(response as T); // Call onSuccess with the data
  }

  if (isErrorResponse(response)) {
    onError(response); // Call onError with the error
  }
}
